import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, LoadingPlaceholder, theme } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { LineItem } from './CreditCardForm.components';

export const LoadingFields = () => {
  return (
    <View>
      <CardNumber />
      <LineItem>
        <View style={styles.row}>
          <ExpirationDate />
          <CVV />
        </View>
      </LineItem>
      <PostalCode />
    </View>
  );
};

const CardNumber = () => {
  const { t } = useLocalizationContext();

  return (
    <LineItem>
      <View style={styles.column}>
        <BodyText size={4}>
          {t('account.credit-card-form.card-number')}
        </BodyText>
        <LoadingPlaceholder rows={1} rowHeight={40} palette="cream" />
      </View>
    </LineItem>
  );
};

const ExpirationDate = () => {
  const { t } = useLocalizationContext();

  return (
    <View style={[styles.column, styles.marginRight]}>
      <BodyText size={4}>
        {t('account.credit-card-form.expiration-date')}
      </BodyText>
      <LoadingPlaceholder rows={1} rowHeight={40} palette="cream" />
    </View>
  );
};

const CVV = () => {
  const { t } = useLocalizationContext();

  return (
    <View style={[styles.column, styles.marginLeft]}>
      <BodyText size={4}>{t('account.credit-card-form.cvv')}</BodyText>
      <LoadingPlaceholder rows={1} rowHeight={40} palette="cream" />
    </View>
  );
};

const PostalCode = () => {
  const { t } = useLocalizationContext();

  return (
    <LineItem>
      <BodyText size={4}>{t('account.credit-card-form.zip-code')}</BodyText>
      <LoadingPlaceholder rows={1} rowHeight={40} palette="cream" />
    </LineItem>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
  },
  column: {
    flex: 1,
  },
  marginRight: {
    marginRight: theme.spacing.large / 2,
  },
  marginLeft: {
    marginLeft: theme.spacing.large / 2,
  },
});
